import { render, staticRenderFns } from "./enrollDetails.vue?vue&type=template&id=048a16d7&scoped=true&"
import script from "./enrollDetails.vue?vue&type=script&lang=js&"
export * from "./enrollDetails.vue?vue&type=script&lang=js&"
import style0 from "./enrollDetails.vue?vue&type=style&index=0&id=048a16d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048a16d7",
  null
  
)

export default component.exports